import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { animated, useSpring } from "react-spring";
import IndexChamp from "../../../components/IndexChamp";

const Index = () => {
  const { t } = useTranslation();
  const theme = window.localStorage.getItem("theme");
  const [mainChampionship, setMainChampionship] = useState("");
  const [secChampionship, setSecChampionship] = useState("");
  const [selected, setSelected] = useState(-1);
  const mainStyle = useSpring({
    backgroundImage: `url(/assets/Index/Main.jpg)`,
    width: selected === 1 ? "100%" : selected === 2 ? "0%" : "70%",
  });

  useEffect(() => {
    axios
      .get(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/championship/getCurrentChampionships`,
      )
      .then(({ data }) => {
        setMainChampionship(data.main_champ.name);
        setSecChampionship(data.second_champ.name);
      })
      .catch(({ response }) => {
        throw new Error(response);
      });
  }, []);

  return (
    <div id="index-container" className="flex">
      <IndexChamp
        id={1}
        defaultWidth={"70%"}
        text={mainChampionship}
        selected={selected}
        setSelected={setSelected}
      />
      <IndexChamp
        id={2}
        defaultWidth={"30%"}
        text={secChampionship}
        selected={selected}
        setSelected={setSelected}
      />
    </div>
  );
};

export default Index;
